import { useLocalObservable } from 'mobx-react-lite';
import { RefObject, useEffect } from 'react';
import { View, Views } from 'react-big-calendar';

import dateService from '@gem/services/date-service';

import {
  IAllDayMaxRowsPresenter,
  useAllDayMaxRowsPresenter,
} from '../Presenters/AllDayMaxRows.presenter';

interface IDnDCalendarPresenterReturnType {
  presenterAllDayMaxRows: IAllDayMaxRowsPresenter;
  presenter: IDnDCalendarPresenter;
}

interface IDnDCalendarPresenter {
  views: View[];
  getTime: (date: Date) => string | null;
}

interface IDnDCalendarPresenterParams {
  calRef: RefObject<HTMLDivElement>;
  currentView: View;
  isDayView: boolean;
  isWeekView: boolean;
}

export const useDnDCalendarPresenter = (
  props: IDnDCalendarPresenterParams
): IDnDCalendarPresenterReturnType => {
  const { calRef, currentView, isDayView, isWeekView } = props;
  const presenterAllDayMaxRows = useAllDayMaxRowsPresenter({ calRef });

  const presenter = useLocalObservable<IDnDCalendarPresenter>(() => ({
    views: [Views.MONTH, Views.WEEK, Views.DAY],

    getTime(date: Date): string | null {
      return dateService.format(date, {
        hour: 'numeric',
        minute: 'numeric',
      });
    },
  }));

  useEffect(() => {
    presenterAllDayMaxRows.setCurrentView(currentView);
  }, [currentView]);

  useEffect(() => {
    if (isDayView) {
      presenterAllDayMaxRows.resetAllDayMaxRows();
    }
  }, [isDayView]);

  useEffect(() => {
    if (isWeekView) {
      presenterAllDayMaxRows.setWeekAllDayMaxRows();
    }
  }, [isWeekView]);

  return { presenter, presenterAllDayMaxRows };
};
